import MyApp from '@quiz-frontend/quiz-builder/pages/_app';
import withRedux from 'next-redux-wrapper';

import { initializeStore } from '../store';

export default withRedux(initializeStore)(MyApp);
